<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">PI Analysis</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                <div v-if="loaded">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="row col-md-6 mr-1">
                            <select class="form-control" @change="projectSelected($event)">
                                <option value="">All Projects</option>
                                <option v-for="project in projects" v-bind:value="project.id">
                                    {{project.projectNumber}} - {{project.projectName}}
                                </option>
                            </select>
                        </div>
                        <button class="btn btn-primary mb-1" @click="resetColumns()">Reset Columns</button>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="d-flex flex-grow-1 justify-content-center">
                                    <ag-grid-vue style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 :gridOptions="gridOptions"
                                                 :columnDefs="columnDefs"
                                                 :rowData="rowData"
                                                 rowSelection='single'
                                                 domLayout='autoHeight'>
                                    </ag-grid-vue>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService';
    import ProjectService from '@/services/ProjectService';
    import { AgGridVue } from "ag-grid-vue";

    export default {
        data: function () {
            return {
                columnDefs: null,
                gridOptions: null,
                rowData: null,
                projects: [],
                loaded: false
            }
        },
        components: {
            AgGridVue
        },
        async beforeMount() {
            let self = this;
            this.gridOptions = {
                defaultColDef: {
                    filter: true, // set filtering on for all cols
                    sortable: true,
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    resizable: true,
                    flex: 1,
                    minWidth: 100,
                },
                onRowSelected: function (event) {
                    self.$router.push(event.node.data.ReportLink);
                },
                rowSelection: 'single'
            }

            const caseInsensitiveComparator = (valueA, valueB) => {
                if (!valueA || !valueB) {
                    return true;
                }

                return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
            };

            this.columnDefs = [
                {
                    headerName: 'Submitted Date', field: 'SubmittedDate',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        return text;
                    },
                    sort: "desc",
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    }
                },
                {
                    headerName: 'Paid Date', field: 'PaidDate',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        return text;
                    },
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    }
                },
                {
                    headerName: 'Submitter Name', field: 'SubmitterName',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Approvals', field: 'Approvals',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Report Name', field: 'ReportName',
                    cellRenderer: (params) => {
                        var text = document.createElement('a');
                        text.href = "javascript:void(0)";
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Project(s)', field: 'Projects',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Type', field: 'Type', width: 75,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Status', field: 'Status',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Project(s) Total', field: 'ProjectTotal',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    }
                }
            ];

            const searchCriteria = {
                IncludeTotal: true,
                ShowPIResultsOnly: true,
                IsAnalysis: true
            }

            this.rowData = await ReportService.getAnalysisReport(searchCriteria)

            this.projects = await ProjectService.getMyManagerProjects();
            this.loaded = true;
        },
        methods: {
            resetColumns: function () {
                this.gridOptions.columnApi.resetColumnState();
            },
            async projectSelected(event) {
                const searchCriteria = {
                    IncludeTotal: true,
                    ShowPIResultsOnly: true,
                    IsAnalysis: true,
                    ProjectId: event && event.target && event.target.value ? event.target.value : null
                }

                this.rowData = await ReportService.getAnalysisReport(searchCriteria)
            }
        }
    }
</script>